//ajax
    let isAjax = true;
    function ghAjax(r) {
        const apiKey = '771587e25caa6dbd1d3a4c3ba91a55ed';
        const apiSecret = 'a794728e1c183f3209129e0fd8981b50';
        const timestamp = Math.round(new Date().getTime()/1000).toString();
        let sign = CryptoJS.HmacSHA256(apiKey + timestamp, apiSecret);
        sign = CryptoJS.enc.Base64.stringify(sign);
        let baseUrl;
        baseUrl = 'https://global.genhigh.com/shopify/';
        // baseUrl = 'https://global.genhigh.com/test/shopify/';
        console.log(r)
        return new Promise(function(resolve, reject) {
            $.ajax({
                type: r.type || 'post',
                dataType: "json",
                url: baseUrl + r.api,
                data: r.data ? JSON.stringify(r.data) : {},
                contentType: 'application/json',
                headers: (r.headers || {
                    'request-id': timestamp,
                    'api-key': apiKey,
                    'timestamp': timestamp,
                    'sign': sign
                }),
                success: function(data) {
                    isAjax = true;
                    resolve(data);
                },
                error: function(request) {
                    console.log("Connection error");
                    isAjax = true;
                }
            });
        });
    }